<template>
  <v-container v-if="!review">
    <v-window v-model="step">
      <v-window-item>
        <PRIVariant />
      </v-window-item>
      <v-window-item>
        <OutpulsedDigits />
      </v-window-item>
      <v-window-item>
        <PBXControl />
      </v-window-item>
    </v-window>
  </v-container>
  <div v-else>
    <ReviewItem
      label="What is your PRI Variant?"
      :value="isdnValue"
    />
    <ReviewItem
      label="What are your outpulsed digits?"
      :value="readableOPD"
    />
    <ReviewItem
      label="Will your PBX control the outpulsing of caller ID number?"
      :value="readablePBXControl"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import PRIVariant from '@/components/cards/PRIVariant.vue';
import OutpulsedDigits from '@/components/cards/OutpulsedDigits.vue';
import PBXControl from '@/components/cards/PBXControl.vue';
import ReviewItem from '@/components/ReviewItem.vue';

export default {
  name: 'PRIQuestions',
  props: {
    review: {
      required: false,
      type: Boolean,
    },
  },
  mounted() {
    if (!this.review) {
      const vm = this;
      vm.hijackStepper(async (goRight) => {
        if ((vm.step === 0 && !goRight) || (vm.step === vm.maxStep && goRight)) {
          vm.unHijackStepper();
          vm.nextSubTab(goRight);
        }
        vm.step += (goRight ? 1 : -1);
      });
    }
  },
  beforeDestroy() {
    this.unHijackStepper();
  },
  methods: {
    ...mapActions(['hijackStepper', 'unHijackStepper', 'nextSubTab']),
  },
  data() {
    return {
      step: 0,
      isdnKey: {
        1: "Standard/NI2",
        2: "Custom/AT&T/5ESS",
        3: "Custom/DMS100",
        4: "Other",
        5: "Unknown",
      },
    };
  },
  computed: {
    ...mapGetters(['getProductIdSelected', 'getProductInfo', 'getQuoteFacts']),
    maxStep() {
      return 2;
    },
    isdnValue() {
      const vm = this;
      return this.isdnKey[vm.getProductInfo().isdn];
    },
    readableOPD() {
      if (this.getProductInfo().opd < 0) {
        return 'Unknown';
      }
      return this.getProductInfo().opd;
    },
    readablePBXControl() {
      const pbx = this.getProductInfo().pbx_control;
      if (pbx === 'y') {
        return 'Yes';
      }
      if (pbx === 'n') {
        return 'No';
      }
      return 'Unknown';
    },
  },

  components: {
    PRIVariant,
    OutpulsedDigits,
    PBXControl,
    ReviewItem,
  },
};
</script>
